import React from 'react';
import { useNavigate } from 'react-router-dom';

const Disclaimer = () => {
  const navigate = useNavigate();
  
  return (
    <div>
      {/* Back to Home Button */}
      <div style={{ 
        maxWidth: '800px', 
        margin: '0 auto', 
        padding: '20px 20px 0 20px'
      }}>
        <button
          onClick={() => navigate('/')}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            background: '#2563eb',
            color: 'white',
            border: 'none',
            padding: '10px 20px',
            borderRadius: '8px',
            fontSize: '0.95rem',
            fontWeight: '600',
            cursor: 'pointer',
            transition: 'all 0.2s',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
          }}
          onMouseOver={(e) => e.target.style.background = '#1d4ed8'}
          onMouseOut={(e) => e.target.style.background = '#2563eb'}
        >
          <span>←</span> Back to Home
        </button>
      </div>
      
      <div style={{ 
      maxWidth: '800px', 
      margin: '0 auto', 
      padding: '40px 20px',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      <h1 style={{ fontSize: '2.5rem', marginBottom: '20px' }}>Disclaimer</h1>
      <p style={{ color: '#666', marginBottom: '40px' }}><strong>Last Updated:</strong> January 1, 2025</p>

      <div style={{ background: '#fef3c7', padding: '20px', borderRadius: '8px', marginBottom: '30px', borderLeft: '4px solid #f59e0b' }}>
        <p style={{ margin: 0, fontWeight: '600', color: '#92400e' }}>
          PLEASE READ THIS DISCLAIMER CAREFULLY BEFORE USING SMARTPDF TOOLS. BY ACCESSING OR USING THE SERVICE, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THIS DISCLAIMER.
        </p>
      </div>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>General Information</h2>
        <p>The information provided by SmartPDF Tools ("we," "us," or "our") on smrtpdftools.com (the "Site") and through our PDF processing services (the "Service") is for general informational purposes only. All information on the Site and Service is provided in good faith; however, we make no representation or warranty of any kind, express or implied, regarding the accuracy, adequacy, validity, reliability, availability, or completeness of any information on the Site or Service.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Service "As Is" Basis</h2>
        <p>SmartPDF Tools is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, expressed or implied, and hereby disclaim and negate all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
        <p style={{ marginTop: '15px' }}>We do not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the Service or otherwise relating to such materials or on any resources linked to the Site.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>File Processing Disclaimer</h2>
        <p><strong>Data Accuracy:</strong> While we strive to provide accurate PDF processing (merging, splitting, compressing, converting), we cannot guarantee that the output files will be error-free or meet your specific requirements. The quality of output depends on various factors including the quality and format of input files.</p>
        <p style={{ marginTop: '15px' }}><strong>Data Loss:</strong> We are not responsible for any data loss, corruption, or quality degradation that may occur during PDF processing. Users are strongly advised to keep backup copies of all original files before using our Service.</p>
        <p style={{ marginTop: '15px' }}><strong>File Compatibility:</strong> We do not guarantee that processed files will be compatible with all PDF readers, devices, or software applications. Some features or formatting may not be preserved during processing.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Limitation of Liability</h2>
        <p>UNDER NO CIRCUMSTANCE SHALL SMARTPDF TOOLS HAVE ANY LIABILITY TO YOU FOR ANY LOSS OR DAMAGE OF ANY KIND INCURRED AS A RESULT OF THE USE OF THE SITE OR SERVICE OR RELIANCE ON ANY INFORMATION PROVIDED ON THE SITE OR THROUGH THE SERVICE. YOUR USE OF THE SITE AND SERVICE AND YOUR RELIANCE ON ANY INFORMATION ON THE SITE OR SERVICE IS SOLELY AT YOUR OWN RISK.</p>
        <p style={{ marginTop: '15px' }}>This includes but is not limited to:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li style={{ marginBottom: '8px' }}>Loss of data, files, or documents</li>
          <li style={{ marginBottom: '8px' }}>Business interruption or loss of profits</li>
          <li style={{ marginBottom: '8px' }}>Damage to computer systems or devices</li>
          <li style={{ marginBottom: '8px' }}>Any indirect, incidental, special, consequential, or punitive damages</li>
          <li style={{ marginBottom: '8px' }}>Errors or omissions in any content or functionality</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Professional Advice Disclaimer</h2>
        <p>The Service is not a substitute for professional advice. We do not provide legal, financial, technical, or any other professional advice. Any reliance you place on information or services from SmartPDF Tools is strictly at your own risk.</p>
        <p style={{ marginTop: '15px' }}>For legal documents, contracts, or other critical files, we strongly recommend consulting with a qualified professional before and after using our Service.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Third-Party Links Disclaimer</h2>
        <p>The Site may contain links to third-party websites or services that are not owned or controlled by SmartPDF Tools. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You acknowledge and agree that we shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Security and Privacy</h2>
        <p>While we implement security measures to protect your data, we cannot guarantee absolute security. File uploads and processing involve transmission over the internet, which is inherently insecure. You acknowledge that you provide files and information at your own risk.</p>
        <p style={{ marginTop: '15px' }}>We recommend not uploading files containing sensitive, confidential, or personally identifiable information unless absolutely necessary.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Service Availability</h2>
        <p>We do not guarantee that the Service will be available at all times or that it will be uninterrupted or error-free. We reserve the right to suspend, withdraw, or restrict access to all or any part of the Service at any time without notice.</p>
        <p style={{ marginTop: '15px' }}>Maintenance, updates, or technical issues may cause temporary interruptions in service availability.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>User Responsibility</h2>
        <p>You are solely responsible for:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li style={{ marginBottom: '8px' }}>Ensuring you have the legal right to upload and process any files you submit</li>
          <li style={{ marginBottom: '8px' }}>Complying with all applicable laws and regulations when using the Service</li>
          <li style={{ marginBottom: '8px' }}>Maintaining backups of your original files</li>
          <li style={{ marginBottom: '8px' }}>Verifying the quality and accuracy of processed files before use</li>
          <li style={{ marginBottom: '8px' }}>The security of your account credentials</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>No Warranty</h2>
        <p>We expressly disclaim all warranties of any kind, whether express or implied, including but not limited to the implied warranties of merchantability, fitness for a particular purpose, and non-infringement. We make no warranty that:</p>
        <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
          <li style={{ marginBottom: '8px' }}>The Service will meet your requirements</li>
          <li style={{ marginBottom: '8px' }}>The Service will be uninterrupted, timely, secure, or error-free</li>
          <li style={{ marginBottom: '8px' }}>The results obtained from the use of the Service will be accurate or reliable</li>
          <li style={{ marginBottom: '8px' }}>Any errors in the Service will be corrected</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Errors and Omissions</h2>
        <p>While we strive to provide accurate information and reliable service, we cannot guarantee that our Site or Service will be free from errors, omissions, or technical problems. We reserve the right to correct any errors, inaccuracies, or omissions and to change or update information at any time without prior notice.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Jurisdiction</h2>
        <p>This Disclaimer shall be governed by and construed in accordance with the laws of the State of California, United States, without regard to its conflict of law provisions. Any legal action or proceeding arising under this Disclaimer will be brought exclusively in the courts located in San Francisco, California.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Changes to This Disclaimer</h2>
        <p>We reserve the right to modify this Disclaimer at any time. Changes will be effective immediately upon posting to the Site. Your continued use of the Service after any changes constitutes acceptance of the modified Disclaimer.</p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{ fontSize: '1.8rem', marginBottom: '15px', color: '#2563eb' }}>Contact Information</h2>
        <p>If you have any questions about this Disclaimer, please contact us at:</p>
        <div style={{ background: '#f3f4f6', padding: '15px', borderRadius: '8px', marginTop: '15px' }}>
          <p style={{ margin: '5px 0' }}><strong>Email:</strong> <a href="mailto:support@smrtpdftools.com" style={{ color: "#2563eb" }}>support@smrtpdftools.com</a></p>
          <p style={{ margin: '5px 0' }}><strong>Website:</strong> smrtpdftools.com</p>
        </div>
      </section>

      <div style={{ marginTop: '40px', padding: '20px', background: '#fef2f2', borderLeft: '4px solid #ef4444', borderRadius: '4px' }}>
        <p style={{ margin: 0, fontSize: '0.95rem', color: '#991b1b' }}>
          <strong>Important:</strong> By using SmartPDF Tools, you acknowledge that you have read this Disclaimer and agree to its terms. If you do not agree with any part of this Disclaimer, please discontinue use of the Service immediately.
        </p>
      </div>
    </div>
    </div>
  );
};

export default Disclaimer;